import ManageClientsWithWealth from "app/client/ManageClientsWithWealth";
import CreatePostNew from "app/createDoc/createPostNew";
import AllKBArticles from "Pages/KnowledgeBase/AllKBArticles";
import CreateKBArticle from "Pages/KnowledgeBase/CreateKBArticle";
import UploadBrokerLogoToCDN from "Pages/Tools/UploadBrokerLogoToCDN";
import UploadImgToCDN from "Pages/Tools/UploadImageToCDN";
import UploadToCDN from "Pages/Tools/UploadToCDN";
import { Suspense } from "react";
import { Redirect, Route, Switch } from 'react-router-dom';
import Automation from '../app/automation/Automation';
import AllBlogs from '../app/Blogs/AllBlogs';
import AllCategories from '../app/Blogs/AllCategories';
import CreateBlog from '../app/Blogs/CreateBlog';
import CreateBlogCategory from '../app/Blogs/CreateCategory';
import ManageClients from '../app/client/ManageClients';
import EditCategory from '../app/CreateCategory/EditCategory';
import CreatePost from '../app/createDoc/createPost';
import Dashboard from '../app/dashboard/Dashboard';
import FunctionsDocumentation from "../app/sharpely/FunctionsDocumentation";
import BankNPA from '../app/Stocks/BankNPA';
import Spinner from "../Components/Atoms/Spinner";
import PaidClientsDashboard from "../Pages/Clients/PaidClientsDashboard";
import Login from '../Pages/UserPages/Login';
import Register1 from '../Pages/UserPages/Register';
import AdminProtectedRoutes from './AdminProtectedRoutes';

export default function AppRoutes() {

  return (
    <Suspense fallback={<Spinner />}>
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/register" component={Register1} />
        <AdminProtectedRoutes exact path="/dashboard" component={Dashboard} />
        <AdminProtectedRoutes exact path="/clients/list" component={ManageClients} />
        <AdminProtectedRoutes exact path="/wealthViewClients/list" component={ManageClientsWithWealth} />
        <AdminProtectedRoutes exact path="/automation" component={Automation} />
        <AdminProtectedRoutes exact path="/banks/banknpa" component={BankNPA} />
        <AdminProtectedRoutes path='/knowledgeBase/all-kb-articles' component={AllKBArticles} />
        <AdminProtectedRoutes path='/knowledgeBase/create-kb-article' component={CreateKBArticle} />
        <AdminProtectedRoutes path="/knowledgeBase/create-new" component={CreatePostNew} />
        <AdminProtectedRoutes path="/knowledgeBase/create" component={CreatePost} />
        <AdminProtectedRoutes path='/blogs/create-category' component={CreateBlogCategory} />
        <AdminProtectedRoutes path='/blogs/all-categories' component={AllCategories} />
        <AdminProtectedRoutes path='/blogs/create-blog' component={CreateBlog} />
        <AdminProtectedRoutes path='/blogs/all-blogs' component={AllBlogs} />
        <AdminProtectedRoutes path='/clients/paid-clients-dashboard' component={PaidClientsDashboard} />
        <AdminProtectedRoutes path='/knowledgeBase/edit-category' component={EditCategory} />
        <AdminProtectedRoutes path='/sharpely/functions-docs' component={FunctionsDocumentation} />
        <AdminProtectedRoutes path='/sharpely/upload-broker-logo' component={UploadBrokerLogoToCDN} />
        <AdminProtectedRoutes path='/tools/upload-img-cdn' component={UploadImgToCDN} />
        <AdminProtectedRoutes path='/tools/upload-to-cdn' component={UploadToCDN} />
        <Redirect to="/login" />
      </Switch>
    </Suspense>
  );
}